/* src/app/forms/produtos/shopee/shopee.component.scss */
:host {
  height: 100%;
  width: 100%;
}
/*# sourceMappingURL=shopee.component.css.map */
